// Report dialog wrapper

import { Modal } from '@/design-system/components/Modal';
import { ReportForm } from './ReportForm';
import { ReportFormData } from '@/client/utils/validationSchemas';

interface ReportDialogProps {
  isOpen: boolean;
  onClose: () => void;
  initialData?: Partial<ReportFormData>;
  onSubmit: (data: ReportFormData) => Promise<void>;
  title?: string;
}

/**
 * Dialog wrapper for report form
 */
export function ReportDialog({
  isOpen,
  onClose,
  initialData,
  onSubmit,
  title,
}: ReportDialogProps) {
  const handleSubmit = async (data: ReportFormData) => {
    await onSubmit(data);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title || (initialData ? 'Edit Report' : 'Add Report')}
      size="lg"
    >
      <ReportForm
        initialData={initialData}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}
